import LANGUAGE_COLORS from "./languageColors.json";

export const getLanguageColor = (language) => {
  if (!language) {
    return "#226FD6";
  }

  if (LANGUAGE_COLORS[language]) {
    return LANGUAGE_COLORS[language];
  }

  return "#226FD6";
};
